export { DtvPlanCardV2Module as default } from "./dtv-plan-card-v2-module";
export { DtvPlanCard } from "./dtv-plan-card-v2";
export type { IDtvPlanCardProps } from "./dtv-plan-card-v2";
